import log from '@/logger'

const interceptorRequestSetup = config => {
  const { method, url, data } = config
  log.info('API Request', method, url, { data })
  return config
}

const interceptorRequestError = error => {
  log.error('API Request', error)
  return Promise.reject(error)
}

export { interceptorRequestSetup, interceptorRequestError }
